<template>
  <div>
    <LibraryBanner title="Your Library">
      <template v-slot:breadcrumbList>
        <li class="active">Your Library: Folders</li>
      </template>
      <template v-slot:buttons>
        <button class="pull-right btn btn-primary add-student-button" @click="openNewStudentModal">New Folder</button>
      </template>
    </LibraryBanner>
    <modal
      v-model="openAddStudentModal"
      title="New Folder"
      size="sm"
      @hide="newStudentName = ''">
      <div class="form-group" :class="{ 'has-error': studentHasConflictingName}">
        <label>Folder Name <StudentPiiTooltip/></label>
        <input
          type="text"
          class="form-control fs-block"
          placeholder="New folder"
          name="newStudentName"
          v-model="newStudentName">
        <small v-if="studentHasConflictingName" class="help-block no-margin-bottom text-danger">You cannot have two folders with the same name.</small>
      </div>
      <div slot="footer">
        <span v-if="!addingStudent">
          <button class="btn btn-default" @click="openAddStudentModal=false">Cancel</button>
          <button
            class="btn btn-primary"
            :disabled="!newStudentName || studentHasConflictingName"
            @click="addNewStudent(newStudentName)">Create</button>
        </span>
        <span v-if="addingStudent" class="text-muted">
          <i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Adding Folder...
        </span>
      </div>
    </modal>
    <div class="container">
      <library-tabs active-tab="Students"/>
      <div
        id="students-tab-panel"
        role="tabpanel"
        aria-labelledby="students-tab">
        <p v-if="loading" class="gb-text-2 text-muted"><i class="fa fa-circle-o-notch fa-spin"/>&nbsp;Loading folders...</p>
        <p v-if="!loading && students.length === 0" class="gb-text-2 text-muted">You haven't created any folders in your library yet.</p>

        <div class="row" v-if="students.length > 0 && !loading">
          <div
            class="col-md-4 col-sm-6"
            v-for="student in students"
            :key="student.uuid">
            <student-card :student="student"/>
          </div>
        </div>
      </div>
      <submit-feedback type="Library" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import StudentCard from '@/components/library/StudentCard'
import SubmitFeedback from '@/components/SubmitFeedback'
import LibraryTabs from '@/components/library/LibraryTabs'
import LibraryBanner from '@/components/library/LibraryBanner'
import StudentPiiTooltip from '@/components/library/StudentPiiTooltip'
import { addStudent } from '@/api/library'
import { libraryQuotasMixin } from '@/components/library/library_quotas_mixin'
import { MessageBox } from 'uiv'

export default {
  name: 'StudentsPage',
  mixins: [libraryQuotasMixin],
  components: {
    StudentCard,
    SubmitFeedback,
    LibraryTabs,
    LibraryBanner,
    StudentPiiTooltip
  },
  data: function() {
    return {
      addingStudent: false,
      openAddStudentModal: false,
      newStudentName: ''
    }
  },
  computed: {
    ...mapState({
      students: state => state.library.students,
      loading: state => state.library.loadingStudents,
      userId: state => state.user.user.uuid
    }),
    ...mapGetters('visibility', ['betaVisibility']),
    studentHasConflictingName() {
      let result = false
      this.students.forEach(student => {
        if (student.name === this.newStudentName) {
          result = true
        }
      })
      return result
    }
  },
  methods: {
    fetchStudents: function() {
      if (this.userId && this.userId.length > 0) {
        this.$store.dispatch('library/fetchStudents', this.userId)
      }
    },
    addNewStudent: function(name) {
      this.addingStudent = true
      addStudent(name, this.userId).then(data => {
        this.fetchStudents()
        this.addingStudent = false
        this.openAddStudentModal = false
        this.newStudentName = ''
        this.$sendEvent('Added New Student')
      })
    },
    openNewStudentModal: function() {
      if (this.maxStudentsReached) {
        MessageBox.alert({
          size: 'md',
          title: 'Maximum folders reached',
          content: this.maxStudentsErrorMessage
        })
        this.sendMaxStudentsReachedEvent()
        return
      }
      this.openAddStudentModal = true
      this.$sendEvent('Clicked Add Student Button')
    }
  },
  created: function() {
    if (this.userId && this.userId !== '') {
      this.fetchStudents()
    }
    this.$sendEvent('Viewed Students Page', {
      ref: this.$route.query.ref
    })
  },
  watch: {
    userId: function() {
      this.fetchStudents()
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/mixins.less';

.fa-spinner {
  font-size: 1em;
}
.add-student-button {
  margin-bottom: 8px;
}
</style>
